import React from 'react';
import styled from 'styled-components';

interface BannerProps {
  message: string;
  onDismiss?: () => void;
}

const BannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #3b82f6;
  color: white;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
`;

const Message = styled.div`
  flex: 1;
  word-wrap: break-word;
  line-height: 1.4;
`;

const DismissButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  margin-left: 12px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    opacity: 0.6;
  }
`;

export const Banner: React.FC<BannerProps> = ({ message, onDismiss }) => {
  return (
    <BannerContainer role="banner" aria-live="polite">
      <Message>{message}</Message>
      {onDismiss && (
        <DismissButton
          onClick={onDismiss}
          aria-label="Dismiss banner"
          type="button"
        >
          ×
        </DismissButton>
      )}
    </BannerContainer>
  );
};
